<div class="" [formGroup]="form">
    <div *ngIf="!editable" fxLayoutAlign="center flex-start">
        <app-collaborator-chips [roleUsers]="onlyUsers" fxFlex="1 1 auto"
        formControlName="user" permissionAdd="true" permissionRemove="true"
        label="{{'ALERTS.ADD_SELECTED_TEAM' | translate}}"></app-collaborator-chips>     
        
        <button mat-raised-button color="accent" (click)="addMembers()">
            <span>{{'ALERTS.ADD_SELECTED_TEAM' | translate}}</span>
        </button>
    </div>

    <mat-selection-list id="list-users" [multiple]="false">
        <div  *ngIf="!editable" >
            <div *ngIf="teamSelected.length" mat-subheader>{{'ALERTS.SELECTED_TEAM' | translate}}</div>
            <div *ngIf="!teamSelected.length" mat-subheader>{{'ALERTS.NO_SELECTED_TEAM' | translate}}</div>
            <button *ngIf="teamSelected.length" mat-raised-button color="accent" (click)="deleteMembers()">
                <span>{{'DELETE_SELECTED_TEAM' | translate}}</span>
            </button>
        </div>
        

       

        <div *ngIf="loadingUsers || loadingGroups"
            style="max-height: 30px; position: relative; left: 50%;">
            <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>

        <ng-container *ngIf="!loadingUsers && !loadingGroups">
            <mat-list-item *ngFor="let member of teamSelected">
                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="auto">
                    <!-- Mat Checkbox -->
                    <mat-checkbox *ngIf="!detailMode"
                        class="example-margin"
                        [checked]="member.selected"
                        (change)="itemCheck(member, $event)"
                        [disabled]="checking"
                        #checkbox>
                    </mat-checkbox>
        
                    <!-- Mat Line with description, clicking here will toggle the checkbox -->
                    <div 
                        mat-line 
                        (click)="toggleCheckbox(member, checkbox)">
                        <strong class="text-truncate" 
                                matTooltip="{{ member.description + 
                                    (currentUser.userId == member.id && member.type == memberType.User ? 
                                        ' (' + ('ALERTS.YOU' | translate) + ')' : '' ) }}">
                            {{ member.description }}
                            <span *ngIf="currentUser.userId == member.id && member.type == memberType.User">
                                ({{ 'ALERTS.YOU' | translate }})
                            </span>
                        </strong>
                    </div>
                </div>
            </mat-list-item>
        </ng-container>

    </mat-selection-list>

</div>